/** Mock appointment IDs used by appointment page demos (avoid importing mockData from note data). */
export const MOCK_ADDENDUM_APPOINTMENT_ID = 'APT-001';
export const MOCK_UNSIGNED_NOTE_APPOINTMENT_ID = 'APT-002';
